export default __webpack_public_path__ + "static/media/GraceHome.84e94aad.PNG";